// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gorYW","text":"styles_text__h3ekV","textVisible":"styles_textVisible__7fqLv","moveUp":"styles_moveUp__ewsqm"};